var _defs, _g, _g2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        isolation: isolate;\n      }\n\n      .st2 {\n        fill: #647f94;\n      }\n\n      .st1 {\n        font-family: MongolianBaiti, 'Mongolian Baiti';\n        font-size: 55.5px;\n      }\n\n      .st1, .st3 {\n        fill: #65b794;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.6,89.6H3.5c-1.8,0-3.3-1.5-3.3-3.3V5.5c-.1-1.8,1.4-3.3,3.3-3.3h48.3c1.8,0,3.3,1.5,3.3,3.3s-1.5,3.3-3.3,3.3H6.8v74.1h72.8c2.6,0,4.7-2.1,4.7-4.7v-16.1c0-1.8,1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3v16.1c0,6.3-5.1,11.3-11.3,11.3h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(29.3 65.8) rotate(-.6) scale(2.2 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "i")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.9,2.2h24.1c.9,0,1.6,1.5,1.6,3.3s-.8,3.3-1.6,3.3h-22.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90.7,5.5v35.5c0,.9-1.5,1.6-3.3,1.6s-3.3-.8-3.3-1.6V7.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.441899f4494ead5e1aca54d10b1c3f05.svg";
export { ForwardRef as ReactComponent };